export const BANNER_TYPES = Object.freeze([
    { value: 1, label: 'Nivel 1' },
    { value: 2, label: 'Nivel 2' },
    { value: 3, label: 'Banner Catalogo' },
    { value: 4, label: 'Nivel 3' },
    { value: 5, label: 'Imagen Swiper' }
]);

export const DEFAULT_BANNER_TYPE = BANNER_TYPES[0].value;

export const BANNER_RECOMMENDED_SIZES = Object.freeze({
    1: '1655 x 615 px',
    2: '1655 x 525 px',
    3: '1200 x 110 px',
    4: '1655 x 400 px',
    5: '1200 x 600 px'
});

export function getBannerTypeLabel(value) {
    const numeric = Number(value);
    const match = BANNER_TYPES.find(type => type.value === numeric);
    return match ? match.label : BANNER_TYPES[0].label;
}

export function getBannerRecommendedSize(value) {
    const numeric = Number(value);
    return BANNER_RECOMMENDED_SIZES[numeric] || BANNER_RECOMMENDED_SIZES[DEFAULT_BANNER_TYPE];
}
